var render = function render(){var _vm=this,_c=_vm._self._c;return _c('board-filtered-search',{attrs:{"data-testid":"epic-filtered-search","tokens":_vm.tokens,"board":_vm.board,"filters":_vm.filters},on:{"setFilters":function($event){return _vm.$emit('setFilters', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }